import React, { useState } from "react";

import { FilterIcon } from "@packages/ds";
import { useIntl } from "react-intl";

import { ActivityFilterOptions } from "Constants/activityTypes";
import { CloseButton } from "ds/Button";
import * as Dropdown from "ds/Dropdown";

import * as S from "./Filter.styles";

type FilterProps = {
  options: ActivityFilterOptions;
  activeOptions: string[];
  onChange: (name: string) => void;
};

const Filter = ({ options, activeOptions, onChange }: FilterProps) => {
  const [expanded, setExpanded] = useState(false);
  const { formatMessage } = useIntl();

  return (
    <Dropdown.Root
      open={expanded}
      onOpenChange={setExpanded}
      id="activity.filter.aria.open"
    >
      <S.Trigger>
        {formatMessage({ id: "filter" })}
        <FilterIcon />
      </S.Trigger>
      <Dropdown.Portal>
        <Dropdown.Content align="end">
          <S.Label>
            {formatMessage({ id: "filter.title" })}
            <CloseButton onClick={() => setExpanded(false)} />
          </S.Label>
          {options.map(option => (
            <Dropdown.CheckboxItem
              key={option.value}
              onCheckedChanged={() => onChange(option.value)}
              checked={activeOptions.includes(option.value)}
            >
              {formatMessage({ id: option.label })}
            </Dropdown.CheckboxItem>
          ))}
        </Dropdown.Content>
      </Dropdown.Portal>
    </Dropdown.Root>
  );
};

export default Filter;
